<template>
  <div style="position: relative;">
    <div v-show='showFontWin' class="tox tox-silver-sink tox-tinymce-aux" style="position: static;display: none;width:100%;left:0;top:0;z-index:999999;" :style='isFullScreen ? "position:fixed;height:100%;" : "position:static;"'>
      <div class="tox-dialog-wrap aPos">
        <div class="tox-dialog-wrap__backdrop" @click.self='cancelFont'></div>
        <div class="tox-dialog tox-confirm-dialog" style="max-width: 320px;">
          <div class="tox-dialog__header">
            <div class="tox-dialog__title" style="font-size: 17px;">自定义字体大小</div>
          </div>
          <div class="tox-dialog__body todo-tox-fit">
            <el-input-number size='medium' clearable :value='fontsize||16' @input='fontsize=arguments[0]' :min='12'  placeholder='请输入字体大小..' id='mySelfFont'></el-input-number> 
          </div>
          <div class="tox-dialog__footer">
            <div class="tox-dialog__footer-start"></div>
            <div class="tox-dialog__footer-end">
              <button title="取消设置" type="button" data-alloy-tabstop="true" tabindex="-1" class="tox-button el-icon-close" @click='cancelFont'> 取消</button>
              <button title="确定设置" type="button" data-alloy-tabstop="true" tabindex="-1" class="tox-button el-icon-check" style="margin-left:15px;" @click='sureFont'> 确定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <textarea ref='superEditor' id="superEditor"></textarea>
  </div>
</template>

<script>
/*import myhttp, {
  isEmpty,
  msgError,
  msgSuccess,
  msgWarn
} from "@/utils/myhttp";*/

let superEditor, createObjectURL;

export default {
  props: [ "value", "readonly" ],
  data() {
    return {
      myValue: this.value||'',
      showFontWin: false,
      fontsize: 16,
      last_fontsize: 16,
      isFullScreen: false,
      matchreg: /\?yanshuvideo=(.+)/,
    };
  },
  created() {
    // console.warn(77777777777);
    this.mediaCache = { __proto__: null, $id$: 1 };
    if ( superEditor === void 0 ) {
      window.tinymce 
      ? this.initTinymce(true)
      : window.myBind('tinymce',this.initTinymce);
    };
  },
  mounted() {
    window.tinymce && this.tinymce();
  },
  beforeDestroy() {
    // console.warn(11111111111, superEditor);
    superEditor.remove();
  },
  activated() {
    // console.error(this);
    // console.warn(77777777776);
    this.mediaCache = { __proto__: null, $id$: 1 };
    this.initTinymce();
  },
  deactivated() {
    // console.error(56666666666);
    // console.warn(11111111111, superEditor);
    superEditor.remove();
  },
  watch: {
    value(newValue) {
      // newValue = this.watchValue(newValue);
      this.myValue = newValue = newValue || newValue === 0 ? newValue + '' : '';
      this.superEditor && this.lastValue !== newValue && this.superEditor.setContent(this.lastValue=this.watchValue(newValue));
    },
    myValue(newValue) {
      // console.error(newValue);
      this.$emit('input', this.lastValue = newValue);
    },
    readonly(bool) {
      this.superEditor.setMode(bool?'readonly':'design');
    }
  },
  methods: {
    initTinymce(loaded) {
      superEditor = window.tinymce;
      createObjectURL = window.URL.createObjectURL;
      superEditor.baseURL = "../../../../static/tinymce";
      superEditor.zh_CN = "../../../../static/tinymce/zh_CN.js";
      loaded !== true && this.tinymce();
    },
    // w.string = '<p><video src="http://1302207710.vod2.myqcloud.com/22414e19vodcq1302207710/2d52e9bd5285890808736469916/UlhhKHwtrLQA.mp4" controls width="876" height="440" img:src="https://www.abcy.com/ysFile/1ff4739290e14d2f9b25c2911673ea10.jpg" alt="手动赋值Video" yanshuvideo="₯₰"></video></p>';
    watchValue(value) {
      // console.error(value);
      // console.warn(this.mediaCache, this.superEditor.mediaCache);
      if( value.includes('yanshuvideo="₯₰"') && value.includes('</video>') ) {
        const mediaCache = this.superEditor.mediaCache || this.mediaCache;
        const div = View.parse('<div>'+value+'</div>')[0], matchreg = this.matchreg; // yanshureg = /\?yanshuvideo=(.+)(\?yanshuvideo=*)/;
        div.querySelectorAll('video').forEach(video=>{
          const src = video.src.replace(matchreg,''), imgsrc = video.getAttribute('img:src').replace(matchreg,'');
          // console.error(src, imgsrc, div);
          video.outerHTML = `<img src="${ imgsrc }?yanshuvideo=${src}" alt="${video.getAttribute('alt')}" width="${video.getAttribute('width')}" height="${video.getAttribute('height')}">`;
        });
        this.superEditor.once('nodechange',value = img=>{
          sleep.clear(50.1398442215,v=>{
            this.superEditor.contentDocument.body.querySelectorAll('img').forEach(img=>{
              const isvideo = img.src.match(/\?yanshuvideo=(.+)/);
              isvideo && (
                img.title = '双击预览视频: ' + ( img.getAttribute('alt') || isvideo[1] ),
                img.setAttribute('video:src', isvideo[1]),
                // mediaCache[isvideo[1]] = img,
                img.matchreg = matchreg,
                ( img.mediaCache = this.superEditor.mediaCache )[img.src] = isvideo[1],
                img.setAttribute('ondblclick', `window.parent.document.PreviewVideo((event=this.src.match(this.matchreg))?(this.setAttribute('video:src',event[1]),this.mediaCache[this.src]=event[1]):this.getAttribute('video:src'))`)
              );
            });
          });
        });
        return this.myValue = div.innerHTML;
      };
      return value;
    },
    cancelFont() {
      this.showFontWin = false;
    },
    sureFont() {
      this.showFontWin(this.last_fontsize=this.fontsize);
      this.showFontWin = false;
    },
    tinymce() {
      let _this = window.a = this, textarea = this.$refs.superEditor, fontWin, myEditor; //, imageList = {}, imageSet = [];
      // console.error(this,superEditor);
      // const mediaCache = { __proto__: null, $id$: 1 };
      superEditor
        .init({
          // selector: "#Editor",
          target: textarea,
          language_url: superEditor.zh_CN, //设置中文
          language: "zh_CN",
          // menu: {
          //   file: {title: '', items: 'newdocument'},
          //   edit: {title: '', items: 'undo redo | cut copy paste pastetext | selectall'},
          //   view: {title: '', items: 'visualaid'},
          //   format: {title: '', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
          // },
          menubar: this.readonly === void 0,
          // statusbar: false,
          plugins: this.readonly !== void 0 ? false : [
            //配置插件：可自己随意选择，但如果是上传本地图片image和imagetools是必要的 // axupimgs xmedia bdmap
            "code advlist autolink link image imagetools axupimgs bdmap table lists charmap preview hr anchor pagebreak lineheight emoticons directionality fullscreen help hr quickbars searchreplace wordcount print"
          ],
          //工具框，也可自己随意配置
          toolbar: this.readonly !== void 0 ? false : 'insertfile undo redo | styleselect formatselect | fontsizeselect | fontselect | forecolor backcolor | bold italic charmap emoticons | alignleft aligncenter alignright alignjustify | ltr rtl bullist numlist outdent indent hr lineheight | link image imagetools axupimgs bdmap table | preview fullscreen',
          link_context_toolbar: true,
          readonly: this.readonly !== void 0,
          height: '100%',
          // disabled: true,
		  lineheight_val: '0 0.25 0.5 0.7 1 1.5 1.6 1.7 1.75 1.8 2 3 4 5',
          fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px 自定义',
          onFontsize: (neww,last,set)=>{
            // console.warn(neww,last,set);
            switch( neww.title ) {
              case '自定义': 
                // console.error(this.superEditor.getContainer());
                this.isFullScreen = Math.abs( window.innerWidth - this.superEditor.getContainer().clientWidth ) <= 10; 
                this.fontsize = window.parseInt(last) || 16;
                this.showFontWin = n=>{
                  ( n *= 1 ) > 7 && set(n+'px',neww.title);
                };
                return false;
            };
          },
		  auto_focus: true,
		  // end_container_on_empty_block: true,
          image_advtab: false,
          branding: false,
          resize: 'both',
          // skin: 'oxide-dark',
          theme:'silver',
          table_default_styles: {
            width: "100%",
            borderCollapse: "collapse"
          },
          image_title: false, // 是否开启图片标题设置的选择，这里设置否
          automatic_uploads: false,
          // images_reuse_filename: true,
          images_upload_url: uploadUrl,
          
          /*file_brower_callback_type: 'file image media',
          file_browser_callback(field_name, url, type, win){
            console.error(field_name, url, type, win);
          },*/

          file_picker_types: 'file image media',
          file_picker_callback(callback,value,meta) {
            // return console.warn(callback,value,meta);
            //要先模拟出一个input用于上传本地文件
            var input = document.createElement('input');
                input.setAttribute('type', 'file');
                //你可以给input加accept属性来限制上传的文件类型
                //例如：input.setAttribute('accept', '.jpg,.png');
                // input.setAttribute('accept', meta.filetype === 'image' ? 'image/*' : meta.filetype === 'media' ? 'video/*,audio/*' : '');
                // input.setAttribute('accept', 'image/*,video/*,audio/*');
            input.click();
            input.onchange = async function() {
              var file = this.files[0], url;
              if( meta.filetype === 'file' || file.type.startsWith('image/') ) {
                url = createObjectURL(file);
                callback( url, {
                  text: file.name,
                  alt: file.name
                } );
                // console.error(url, file);
                return;
              };

              $.getVideoBase64( url = createObjectURL(file) ).then(_url=>{
                var _file;
                // console.error(_url);
                _url = createObjectURL( _file = $.toFile(_url,'upload.png') );
                // console.error( _url, _file, _file.size );
                callback( _url, {
                  text: file.name,
                  alt: file.name
                });
                
                $('body > .tox-tinymce-aux .tox-dialog__footer-end').children[1].onclick = ()=>{
                  // console.error(555555555);
                  myEditor.on('nodechange',_file=event=>{
                    const img = window.img = event.element;
                    if( img.nodeName !== 'IMG' ) return;
                    myEditor.off('nodechange',_file);
                    // console.error(event);
                    ( myEditor.mediaCache[ event = myEditor.mediaCache.$id$++ ] = file ).blobUrl = _url;
                    img.title = '双击预览视频: ' + file.name;
                    img.setAttribute('isvideo',event);
                    img.setAttribute('video:src',url);
                    img.matchreg = _this.matchreg, img.mediaCache = myEditor.mediaCache;
                    img.setAttribute('ondblclick',`window.parent.document.PreviewVideo((event=this.src.match(this.matchreg))?(this.setAttribute('video:src',event[1]),this.mediaCache[this.src]=event[1]):this.getAttribute('video:src'))`);
                  });
                  /*sleep(250).then(res=>{
                    forEach(myEditor.contentDocument.body.children,el=>{
                      el.
                    });
                    console.error(myEditor.contentDocument.body.lastElementChild);
                  });*/
                  // myEditor.execCommand('insertHTML',false,`<video src="${ url }"></video>`);
                };
              });
              return;
              
              // return console.error(file,value,meta);

              /*const Ling = $.loading('正在上传..');
              const url = await myhttp.storage(file);
              Ling.close.sleep(Ling,100);
              if( !url ) return msgError('上传失败，请检查!');*/
              /*callback( url, {
                text: file.name,
                alt: file.name
              });*/

              /*var xhr, formData;
              console.log(file.name,file);
              xhr = new XMLHttpRequest();
              xhr.withCredentials = false;
              xhr.open('POST', '/demo/upimg.php');
              xhr.onload = async function() {
                  await sleep(500);
                  Ling.close();
                  callback('哈哈哈',{text:file.name,alt:file.name});
                  return;
                  var json;
                  if (xhr.status != 200) {
                      failure('HTTP Error: ' + xhr.status);
                      return;
                  }
                  json = JSON.parse(xhr.responseText);
                  if (!json || typeof json.location != 'string') {
                      failure('Invalid JSON: ' + xhr.responseText);
                      return;
                  };
                  callback(json.location);
              };
              formData = new FormData();
              formData.append('file', file, file.name );
              xhr.send(formData);*/

              /*if (meta.filetype == 'file') {
                callback('mypage.html', {text: 'My text'});
              }
              // Provide image and alt text for the image dialog
              if (meta.filetype == 'image') {
                callback('myimage.jpg', {alt: 'My alt text'});
              }
              // Provide alternative source and posted for the media dialog
              if (meta.filetype == 'media') {
                callback('movie.mp4', {source2: 'alt.ogg', poster: 'image.jpg'});
              }*/

            };

          },
          
          // 图片异步上传处理函数
          images_upload_handler: (blobInfo, success, failure, ing) => {
            let blob = blobInfo.blob(), url;
            console.log(blobInfo, success, failure, url, blob);
            if( url = this.superEditor.isUploading ) {
              // ++this.superEditor.isUploading;
              // $Loading(`正在批量上传第${ url }张图片..`, textarea.parentNode, 'rgba(0, 0, 0, 0.4)');
              /*const form = new FormData();
              form.append( 'file', blob + '' === '[object File]' ? blob : new File([blob],blobInfo.filename(),{type:blob.type}) ); // $.toFile(coverPath,'upload.png')
              const res = await this.$post('/file/uploadLinux',form,false);
              res.isuccess && ( url = window.ONFILE + res.data.data );*/
              url.push( blob + '' === '[object File]' ? blob : new File([blob],blobInfo.filename(),{type:blob.type}) );
              url = createObjectURL(blob);
            } else {
              url = createObjectURL(blob);
            };
            // console.error(this.superEditor.isUploading);
            return success( url );
            // return success('data:image/jpeg;base64,'+blobInfo.base64()), console.error(blobInfo, success, failure, url);
          },
          init_instance_callback: function(editor) {
            /*editor.on("keyup", () => {
              // 获取富文本编辑器里面的内容
              _this.Editortext = editor.getContent({ source_view: true });
            });*/
          }
        })
        .then(editor => {
          // console.warn(editor);
          if(!(editor||'').length) return;
          const imgRegExp = /<img\s*src="(blob:[^"]+)"/g;
          this.readonly === void 0 && ( fontWin = $('button.tox-tbtn[title="格式"]',textarea.parentNode) ) && ( fontWin.children[0].textContent = '格式' );
          // 初始化富文本编辑器里面的内容
          // console.warn(editor);
          ( editor = myEditor = this.$host.superEditor = this.superEditor = editor[0] ).setContent(this.watchValue(this.value||''));
          editor.mediaCache = this.mediaCache || ( this.mediaCache = { __proto__: null, $id$: 1 } );

          // editor.imageList = imageList;
          editor.uploadImgByStr = upload=>{
            let temp, tempStr, tempIndex = 0, overIndex = 0,
                initStr = editor.getContent({ source_view: true }), 
                str = initStr, imageList = { __proto__: null };
            // console.error(imageList);
            return new Promise((suc,err)=>{
              const next = ()=>{ /*this.myValue = editor.setContent(str),*/ suc(str); }
              for( temp of initStr.matchAll(imgRegExp) ) {
                // console.error(temp);
                let blobUrl = temp[1]; ++tempIndex;
                if( imageList[ blobUrl ] !== void 0 ) continue;
                imageList[ blobUrl ] = '';
                // if( !( blob = await fetch(blobUrl).then(r=>r.blob()) ) ) continue;
                fetch(blobUrl).then(ini=>{
                  // console.error(blob);
                  ini.blob().catch(e=>++overIndex >= tempIndex && next()).then(blob=>{
                    // console.error( blobUrl.split('/').item(-1)+blob.type.replace('image/','') );
                    upload( new File([blob],blobUrl.split('/').item(-1)+'.'+blob.type.replace('image/','')) ).then(realUrl=>{
                      imageList[ blobUrl ] = realUrl;
                      tempStr = str;
                      while( true ) {
                        tempStr = str.replace(blobUrl,realUrl);
                        if( str === ( str = tempStr ) ) break;
                      };
                      ++overIndex >= tempIndex && next();
                    }).catch(e=>++overIndex >= tempIndex && next());
                  });
                });
              };
              tempIndex === 0 && next();
            });
          };

          editor.isUploading = false;
          editor.upload = async (masker)=>{
            const imglist = editor.isUploading = [], imgCache = { __proto__: null }, videoCache = { __proto__: null };
            // const loader = window.$Loading('正在批量上传图片..', editor.el, 'rgba(0, 0, 0, 0.4)');
            const imgs = await editor.uploadImages(/*imgs=>{ // { element: img, status: true }
              // loader.close();
              getContent();
              window.setTimeout( v=>{
                getContent();
                editor.isUploading = false;
              }, 0 );
            }*/);
            // return console.error(imgs);
            var p, img, loader, i = 0, tips = '', is = false;
            if( imgs.length > -1 ) {
              img = ( loader = $Loading('正在上传..', masker || textarea.parentNode, 'dark') ).$el;
              p = img.querySelector('.el-loading-text');
            };
            // console.warn(masker);
            // return NaN;
            const mediaCache = editor.mediaCache;
            for( img of imgs ) {
              let file = imglist[i], video = mediaCache[ ( img = img.element ).getAttribute('isvideo') ], index = ++i;

              img.setAttribute('style', 'max-width:100%;max-width:100vw;height:auto;');
              if( !img.src.startsWith('http') ) {

                /*let res = await A.tcUpload( file, (progress)=>{
                  // console.error('当前上传进度: ',progress);
                  p.textContent = `正在上传第${ index }张图片: "${ file.name }"  ${ ( progress.percent * 100 ).toFixed(1) + '%' }`;
                  // this._ProgressSpan && ( this._ProgressSpan.textContent = ( progress.percent * 100 ).toFixed(1) + '%' );
                } );
                !res || res[0] === false
                ? res = false
                : ( ( res = res[1] ).isuccess = true, res = res.data = { path: res.video.url, file: res.video.url, cover: (res.cover||0).url || '' } );
                console.warn('最终响应:: ', res);*/


                p.textContent = `正在上传第${ index }张图片: "${ file.name }"..`;
                const form = new FormData(); form.append( 'file', file );
                let res = await this.$post('/opportunity/auth-file/uploadLinux', form, false);
                res = !res.isuccess ? false : { path: res.data.data, file: res.data.data };

                res //.isuccess 
                ? (
                  is = true,
                  imgCache[ img.src ] = res.file, // window.ONFILE + res.data.data, 
                  img.hasAttribute('video:src') && ( videoCache[img.src] = img.getAttribute('video:src') )
                )
                : tips += `上传第${ index }张图片失败: "${ video ? video.name : file.name }" ！<br>`;
                if( !res && !video ) continue; // .isuccess

              } else is = true;

              if( !video ) continue;

              // file = mediaCache[img.getAttribute('isvideo')];
              file = video;
              p.textContent = `正在上传视频: "${ file.name }"`;

              // const form = new FormData(); form.append( 'file', file );
              // const res = ( await this.$post('/file/uploadLinux',form,false) ).isuccess;

              /*let res = await A.tcUpload( file, (progress)=>{
                // console.error('当前上传进度: ',progress);
                p.textContent = `正在上传视频: "${ file.name }"  ${ ( progress.percent * 100 ).toFixed(1) + '%' }`;
                // this._ProgressSpan && ( this._ProgressSpan.textContent = ( progress.percent * 100 ).toFixed(1) + '%' );
              } );
              !res || res[0] === false
              ? res = false
              : ( ( res = res[1] ).isuccess = true, res = res.data = { path: res.video.url, file: res.video.url, cover: (res.cover||0).url || '' } );
              console.warn('最终响应:: ', res);*/
              
              const form = new FormData(); form.append( 'file', file );
              let res = await this.$post('/opportunity/auth-file/uploadLinux', form, false);
              res = !res.isuccess ? false : { path: res.data.data, file: res.data.data };

              if( res ) {
                is = true;
                delete mediaCache[img.getAttribute('isvideo')];
                img.removeAttribute('isvideo');
                img.setAttribute('video:src', videoCache[img.src] = /*window.ONFILE + */res.file);
              } else {
                tips += `上传视频失败: "${ file.name }" ！<br>`;
              };

            };

            editor.isUploading = false;
            const html = getContent();

            if( tips === '' ) {
              imgs.length > 0 && alertSuccess('所有资源都上传成功！','上传媒体成功');
            } else {
              ( is ? alertWarn : alertError )(tips,'部分资源上传失败(支持再次上传)',10000);
              if( !is ) return loader && loader.close(), NaN;
            };

            if( imgs.length === 0 ) return loader && sleep(200,v=>loader.close()), html;
            
            const div = View.parse('<div>'+html+'</div>')[0], yanshureg = /\?yanshuvideo=(.+)(\?yanshuvideo=*)/;
            div.querySelectorAll('img').forEach(img=>{
              var oldsrc = img.src, videosrc = videoCache[oldsrc] || mediaCache[oldsrc];
              if( oldsrc.startsWith('http') && !videosrc ) return; // console.error(oldsrc,videosrc,img,mediaCache);
              imgCache[oldsrc] && ( img.src = imgCache[oldsrc] );
              img.setAttribute('style', 'max-width:100%;max-width:100vw;height:auto;');
              console.log('视频: ', videosrc,oldsrc,img,img.src);
              videosrc && (
                img.outerHTML = `<video src="${videosrc}" controls style="max-width:100%;max-width:100vw;height:auto;" width="${img.getAttribute('width')}" height="${img.getAttribute('height')}" img:src="${ oldsrc = img.src.replace(yanshureg,'?yanshuvideo=') }" poster="${ oldsrc }" alt="${img.alt}" yanshuvideo="₯₰"></video>`
              );
            });

            loader && sleep(200,v=>loader.close());
            // console.warn(div,videoCache,mediaCache,imgs,imglist,html);
            return div.innerHTML;

          };

          fontWin = ( ( editor.el = textarea.parentNode ).previousElementSibling || 0 ).style;

          /*const doc = document; // .documentElement;
          doc.PreviewVideo || ( 
            doc.documentElement.insertAdjacentHTML(
                'beforeEnd',
                `
                <div id=PreviewVideo style=transform:translateY(100%) >
                    <video src="" controls autoplay width=100% height=100%></video>
                    <i class=el-icon-close title=关闭 ></i>
                </div>
                `
            ),
            ( doc.documentElement.PreviewVideoEl = doc.documentElement.lastElementChild ).children[1].onclick = function(){
                this.previousElementSibling.pause();
                this.parentElement.style.transform = 'translateY(100%)';
            },
            doc.PreviewVideo = function(url){
                const el = this.documentElement.PreviewVideoEl;
                if( el ) {
                  el.firstElementChild.src = url;
                  return el.style.transform = "";
                };
            }
          );*/

          // console.error(editor);
          // $('button[title="插入/编辑图片"]',editor.el).title = '插入/编辑图片(支持视频)';
          editor.show();
          const getContent = ()=>{
            return this.myValue = editor.getContent({ source_view: true });
            // console.warn(editor.contentDocument.body.innerHTML);
          };
          // editor.on('getcontent',v=>console.error(4444444)); // input
          editor.on('nodechange',getContent);
          editor.on('wordcountupdate',getContent);
          editor.on('click',event=>{
            const videosrc = event.target.getAttribute('video:src');
            // console.error(videosrc);
            videosrc && sleep(100, async tox=>{
              tox = $('body > .tox .tox-pop--bottom');
              if( !tox ) return;
              // console.error(tox, tox.PreviewVideo);
              if( tox.PreviewVideo === tox.lastElementChild && tox.PreviewVideo ) return tox.PreviewVideo.style.opacity = 1;
              tox.insertAdjacentHTML('beforeEnd','<div class=tox-previewvideo style=opacity:0>双击预览视频</div>');
              ( tox = tox.PreviewVideo = tox.lastElementChild ).onmousedown = function(){
                // console.error(2222222222);
                document.PreviewVideo(this.src);
              };
              tox.src = videosrc;
              // console.error(tox.src,videosrc);
              // console.error(tox,tox.parentElement.outerHTML);
              await sleep(50);
              tox.style.opacity = 1;
            });
          });
        });
    }
  }
};
</script>

<style>
  #mySelfFont {
      /*background: white;*/
      width:100%;
      /*color:black;*/
      position:relative;
  }
  #mySelfFont > .el-input {
      display: inline-block;
      width: 100%;
  }
  #mySelfFont > span {
      position: absolute;
      height: 100%;
      line-height: 36px;
      text-align: center;
      /*background: darkgray;*/
      top: 0px; right: 0px;
      border-radius: 0px;
  }
  #mySelfFont > span:first-child {
      left: 0px; right: auto;
  }
  #mySelfFont input {
      width: 100%;
      text-indent: 0.7em;
      padding: 0px;
      position: relative;
  }
  /*#PreviewVideo {
    position:fixed;
    left:0;
    top:0;
    width:100%;
    height:100%;
    z-index:999999999999999999999999;
    background:radial-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.9));
    transition: all 200ms ease-in-out;
  }
  #PreviewVideo > i {
    position: absolute;
    z-index: 100;
    font-size: 40px;
    right: 35px;
    top: 35px;
    color: #e92f2f;
    background: rgba(255,255,255,0.6);
    border-radius: 100%;
    padding: 10px;
    cursor: pointer;
    transition: all 300ms ease-in-out;
    ;transform: translateY(0%);
  }
  #PreviewVideo > i:hover {
    background: rgba(255,255,255,0.95)!important;
  }*/
  .tox .tox-previewvideo {
    background: #222f3e;
    color: white;
    padding: 7px;
    position: absolute;
    width: 150px;
    text-align: center;
    border-radius: 50px;
    top: 2px;
    left: 130%;
    transition: all 250ms linear;
    z-index: 77;
    cursor: pointer;
  }
  .tox .tox-previewvideo:hover {
    opacity: 0.75!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/$Tinymce.vue